import { render } from "./CustomerName.vue?vue&type=template&id=5cbca7e3&scoped=true"
import script from "./CustomerName.vue?vue&type=script&lang=js"
export * from "./CustomerName.vue?vue&type=script&lang=js"

import "./CustomerName.vue?vue&type=style&index=0&id=5cbca7e3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5cbca7e3"

export default script